import { render, staticRenderFns } from "./ApprovalCriteria.vue?vue&type=template&id=a38f6c96&scoped=true"
import script from "./ApprovalCriteria.vue?vue&type=script&lang=ts"
export * from "./ApprovalCriteria.vue?vue&type=script&lang=ts"
import style0 from "./ApprovalCriteria.vue?vue&type=style&index=0&id=a38f6c96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38f6c96",
  null
  
)

export default component.exports